import React from 'react'
import classNames from 'classnames'
import type { TAdvancePaymentCalculatorFormulaTermProps } from './types'
import './styles.scss'

export const AdvancePaymentCalculatorFormulaTerm: React.FC<TAdvancePaymentCalculatorFormulaTermProps> = ({
  title,
  description,
  className,
}) => {
  return (
    <div className={classNames('advancePaymentCalculatorFormulaTerm', className)}>
      <div className="h5">{title}</div>
      {description && <div className="advancePaymentCalculatorFormulaTerm__description text_small">{description}</div>}
    </div>
  )
}
